exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mylabel[data-v-1acf0120]{width:100%;text-align:center;margin:auto;font-size:2.2em;font-style:italic;text-anchor:middle;color:#000}.card[data-v-1acf0120]{height:100px;border-radius:10px;margin-bottom:10px;background-color:#d9dfe9}.text-xl[data-v-1acf0120]{font-size:20px;font-weight:700}.text-lg[data-v-1acf0120]{font-size:16px;font-weight:700}.text-md[data-v-1acf0120]{font-size:14px;color:green}.container[data-v-1acf0120]{margin-left:10px}.notif-panel[data-v-1acf0120]{height:100%;max-height:200px;background-color:#d9dfe9;overflow-y:scroll;padding-bottom:10px}.notif-title[data-v-1acf0120]{min-height:10%;background-color:#367fa9}.notif-content[data-v-1acf0120]{height:90%;margin-top:5px}.notif-entry[data-v-1acf0120]{min-height:30px;background-color:#fff;border-radius:10px;padding:10px;margin:10px;max-width:90%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/views/dashboard/DashboardLibrarian.vue?vue&type=style&index=0&id=1acf0120&prod&scoped=true&lang=css&
// module id = 969
// module chunks = 0